import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Accordion from 'react-bootstrap/Accordion';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";
import { adminMainUrl } from '../../../../Config';
import AddIATA from './IATAOffcanvas/AddIATA';
import { getIATAAirline, getOrganisationIATAList } from '../../../../Redux/action/Organisation/OrganisationListAction';
import Beatloader from '../../../../Common/Loaders/Beatloader';
import EditIATA from './IATAOffcanvas/EditIATA';
import Swal from 'sweetalert2';


const IATATab = ({ token, user_id, b64id, refresh }) => {
    const dispatch = useDispatch();
    const [showLoader, setShowLoader] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [iata_organisation_id, set_iata_organisation_id] = useState("");
    const [orgnaisation_list, set_organisation_list] = useState([]);

    //add modal
    const [showAdd, setShowAdd] = useState(false);
    const handleOpenAddModal = () => { setShowAdd(true) }
    const handleCloseAddModal = () => { setShowAdd(false) }


    //edit modal
    const [showEdit, setShowEdit] = useState(false);
    const handleOpenEditModal = () => { setShowEdit(true) }
    const handleCloseEditModal = () => { setShowEdit(false) }


    //organisation options

    useEffect(() => {
        if (user_id && token && b64id) {
            dispatch(getIATAAirline());
            let id = atob(b64id);
            if (id) {
                dispatch(getOrganisationIATAList(token, user_id, id))
            }
        }
    }, [token, user_id]);

    const refreshIATA = () => {
        try {
            if (user_id && token) {
                // dispatch(getIATAAirline());
                let id = atob(b64id);
                if (id) {
                    dispatch(getOrganisationIATAList(token, user_id, id))
                }
            }
        } catch (error) {
            console.log(error);
        }
    }


    const {
        IATAAirlineList,
        loadingOrganisationIATAList,
        OrganisationIATAList,
        OrganisationIATAListError,
    } = useSelector(state => state?.OrganisationListReducer);


    useEffect(() => {
        if (loadingOrganisationIATAList) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
        if (OrganisationIATAList) {
            // let arr = [];
            set_organisation_list(OrganisationIATAList);
        }
    }, [loadingOrganisationIATAList, OrganisationIATAList, OrganisationIATAListError,])

    let [airlineOptions, setAirlineOptions] = useState([]);
    useEffect(() => {
        if (IATAAirlineList) {
            let arr = [];
            IATAAirlineList.map(val => { arr.push({ value: val.id, label: `${val.name}` }) });
            setAirlineOptions(arr)
        }
    }, [IATAAirlineList]);

    const initialValues = {
        customer_id: 1,
        preferred_cartage_handler_for_air: "",
        preferred_cartage_handler_for_lcl: "",
        preferred_cartage_handler_for_fcl: "",
        customer_services_for_sea: "",
        customer_services_for_air: "",
        cartage_coordinator_for_sea: "",
        cartage_coordinator_for_air: "",
        account_manager_for_sea: "",
        account_manager_for_air: "",
        currency_uplift_air_percentage: "",
        currency_uplift_air_value: "",
        currency_uplift_sea_percentage: "",
        currency_uplift_sea_value: ""
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: values => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }

                }
                values.customer_id = atob(b64id)
                axios.post(`${adminMainUrl}/api/organization/shipper-add-update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            refresh();
                            setDisableSubmit(false);
                        } else {
                            toast.error(response.data.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(err => {
                        let msg = "Internal server error!";
                        if (err.response) {
                            if (err.response.data) {
                                if (err.response.data.msg) {
                                    msg = err.response.data.msg
                                }
                            }
                        };
                        toast.error(msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                setDisableSubmit(false);
                toast.error(error.message);
            }
        }
    });

    const handleEditIATA = (id) => {
        set_iata_organisation_id(id);
        setShowEdit(true);
    }

    const handleDelete = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you really want to delete this item?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel",
        })
            .then((result) => {
                if (result.isConfirmed) {
                    let values = { id: id }
                    let config = { headers: { "auth-token": token, 'user_id': user_id } }
                    return axios.post(`${adminMainUrl}/api/organization/iata/delete`, values, config);
                } else {
                    throw new Error("Deletion canceled");
                }
            })
            .then((response) => {
                Swal.fire("Deleted!", "Your item has been deleted.", "success");
                refreshIATA();
            })
            .catch((error) => {
                if (error.message === "Deletion canceled") {
                    Swal.fire("Cancelled", "Your item is safe.", "info");
                } else {
                    Swal.fire("Error!", error.response?.data?.message || "Something went wrong.", "error");
                }
            });
    };

    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <div className='card p-3'>
                        <div className="card-body">
                            <div className="row d-flex justify-content-end">
                                <div className="col-md-6 d-flex justify-content-end">
                                    <button className="btn btn-danger btn-sm" onClick={() => { setShowAdd(true) }}>+Add</button>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-striped table-sm">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Airline</th>
                                            <th scope="col">Account No.</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            orgnaisation_list.length ?
                                                orgnaisation_list.map((val, index) => {
                                                    return <tr key={index + 1}>
                                                        <th scope="row">{index + 1}</th>
                                                        <td>{val?.airline}</td>
                                                        <td>{val?.account_no}</td>
                                                        <td>
                                                            <button className="btn btn-sm btn-outline-primary me-1" onClick={() => { handleEditIATA(val.id) }}><i className="fas fa-edit"></i></button>
                                                            <button className="btn btn-sm btn-outline-danger ms-1" onClick={() => { handleDelete(val.id) }} ><i className="fa-solid fa-trash"></i></button>
                                                        </td>
                                                    </tr>
                                                })
                                                :
                                                <tr>
                                                    <td colSpan={4}>No data found</td>
                                                </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>

                        </div>
                        <AddIATA show={showAdd} handleClose={handleCloseAddModal} refreshIATA={refreshIATA} airlineOptions={airlineOptions} token={token} user_id={user_id} b64id={b64id} />
                        <EditIATA show={showEdit} handleClose={handleCloseEditModal} refreshIATA={refreshIATA} airlineOptions={airlineOptions} token={token} user_id={user_id} b64id={b64id} iata_organisation_id={iata_organisation_id} />
                    </div>
            }

        </>


    )
}

export default IATATab